import { GetterTree } from 'vuex'
import { TransportsState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<TransportsState, RootState> = {
    transports:state => state.transports ?? [],
    transportProtocols:state => state.transportProtocols ?? [],
    protocolParameters:state => state.protocolParameters ?? [],
    transportsMultichannel:state => state.transportsMultichannel ?? [],
};